import React from 'react';
import { Outlet } from 'react-router-dom';
import OfferFooter from '../../components/common/OfferFooter/OfferFooter';

const Layout: React.FC = () => {
  return (
    <>
      <Outlet />
      <OfferFooter />
    </>
  );
};

export default Layout;
